import { render } from "./ContenutoSessione.vue?vue&type=template&id=09939f9e"
import script from "./ContenutoSessione.vue?vue&type=script&lang=js"
export * from "./ContenutoSessione.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__